import axios from 'axios'
import request from '@/utils/request'

let HREF_API = process.env.VUE_APP_HREF_API

const NODE_ENV=process.env.NODE_ENV

let HOST='//www.yiihuu.com'
if(NODE_ENV!='production'){
    HOST='http://test.yiihuu.com:81'
}

export function list(data_) {
    return request({
        url: '/api/refund/list',
        method: 'get',
        params: data_
    })
}
export function vipList(data_) {
    return request({
        url: '/api/refund/vip_list',
        method: 'get',
        params: data_
    })
}
export function albumList(data_) {
    return request({
        url: '/api/refund/album_list',
        method: 'get',
        params: data_
    })
}
export function payInfo(data_) {
    return request({
        url: '/api/refund/pay_info',
        method: 'get',
        params: data_
    })
}
export function reason(data_) {
    return request({
        url: '/api/refund/reason',
        method: 'get',
        params: data_
    })
}
export function store(data_) {
    return request({
        url: '/api/refund/store',
        method: 'post',
        data: data_
    })
}
export function detail(data_) {
    return request({
        url: '/api/refund/detail',
        method: 'get',
        params: data_
    })
}
export function setStatus(data_) {
    return request({
        url: '/api/refund/set_status',
        method: 'post',
        data: data_
    })
}

export function erweima2(data_) {
    return new Promise((resolve, reject) => {
        $.ajax({
            url: `${HOST}/app/erweima2/index.php`,
            type: 'get',
            data:data_,
            // xhrFields: {
            //     withCredentials: true//设置withCredentials 允许跨域带Cookie
            // },
            success: function (data) {
                resolve(data)
            },
            error: function (data) {
                reject(data)
            }
        });
    })
}
export function ajaxCenterInfo(data_) {
    return new Promise((resolve, reject) => {
        $.ajax({
            url: `${HOST}/app/weixin/ajax_center_info.php`,
            type: 'get',
            data:data_,
            dataType: 'json',
            success: function (data) {
                resolve(data)
            },
            error: function (data) {
                reject(data)
            }
        });
    })
}

// 发票
export function billList(data_) {
    return request({
        url: '/api/bill/list',
        method: 'get',
        params: data_
    })
}
export function billVipList(data_) {
    return request({
        url: '/api/bill/vip_list',
        method: 'get',
        params: data_
    })
}
export function billAlbumList(data_) {
    return request({
        url: '/api/bill/album_list',
        method: 'get',
        params: data_
    })
}
export function billCardList(data_) {
    return request({
        url: '/api/bill/card_list',
        method: 'get',
        params: data_
    })
}
export function billPayInfo(data_) {
    return request({
        url: '/api/bill/pay_info',
        method: 'get',
        params: data_
    })
}
export function billStore(data_) {
    return request({
        url: '/api/bill/store',
        method: 'post',
        data: data_
    })
}
export function billDetail(data_) {
    return request({
        url: '/api/bill/detail',
        method: 'get',
        params: data_
    })
}
export function billSetStatus(data_) {
    return request({
        url: '/api/bill/set_status',
        method: 'post',
        data: data_
    })
}